export default __webpack_public_path__ + "52cbcda07368c31507475ccdff8a2c0d.jpg";